<script lang="ts">
import { defineComponent, h, unref } from 'vue';

import { classNames } from '@components/utils';

import { makeDimensionProps, useDimensions, useRender } from '../../../composable';
import { makeResponsiveProps, useAspectStyles } from '../composable';

export const componentName = 'CdsResponsive';
export default defineComponent({
  name: componentName,
  props: {
    ...makeResponsiveProps(),
    ...makeDimensionProps()
  },
  setup(props, { slots }) {
    const { aspectStyles } = useAspectStyles(props);
    const { dimensionsStyles } = useDimensions(props);

    useRender(() =>
      h(
        'div',
        {
          class: classNames('cds-responsive', { 'cds-responsive--inline': props.inline }),
          style: unref(dimensionsStyles)
        },
        [
          h('div', {
            class: classNames('cds-responsive__sizer'),
            style: unref(aspectStyles)
          }),
          slots.additional?.(),
          slots.default &&
            h('div', { class: classNames('cds-responsive__content', props.contentClass) }, slots.default?.())
        ]
      )
    );

    return {};
  }
});
</script>

<style lang="scss">
@import './CdsResponsive';
</style>
